<aside id="dev-tools-banner"
       class="fixed inset-x-0 bottom-0 z-50 w-full rounded-b-lg border-t border-fdk-border bg-fdk-background px-3 py-2 shadow-[0_-2px_8px_rgba(0,0,0,0.12)]"
       aria-label="Developer tools">
  <div class="dev-tools-layout flex min-h-10 w-full items-center justify-between gap-2 sm:gap-3">
    <div class="dev-tools-label flex shrink-0 items-center gap-1.5 fdk-type-label-large text-fdk-secondary">
      <span>Dev tools</span>
    </div>

    <div class="dev-tools-actions ml-auto flex items-center justify-end gap-2">
      <div *ngIf="showResetConnections" class="dev-tool-action-group relative">
        <fdk-button type="button"
                    variant="secondary"
                    id="dev-tools-reset-connections-button"
                    aria-describedby="dev-tools-reset-connections-tooltip"
                    [attr.aria-busy]="resetState === 'loading'"
                    [disabled]="resetState === 'loading'"
                    (click)="resetConnections.emit()">
          <span class="flex items-center justify-center gap-2">
            <fdk-spinner *ngIf="resetState === 'loading'" />
            <fdk-icon *ngIf="resetState === 'success'" name="checkmark" [size]="16" />
            <fdk-icon *ngIf="resetState === 'error'" name="cross" [size]="16" />
            <span>{{resetButtonLabel}}</span>
          </span>
        </fdk-button>
        <span id="dev-tools-reset-connections-tooltip"
              class="dev-tool-tooltip"
              role="tooltip">
          {{resetConnectionsTooltip}}
        </span>
      </div>

      <div *ngIf="showSkip" class="dev-tool-action-group relative">
        <fdk-button type="button"
                    variant="primary"
                    id="dev-tools-skip-button"
                    aria-describedby="dev-tools-skip-tooltip"
                    (click)="skip.emit()">Skip
        </fdk-button>
        <span id="dev-tools-skip-tooltip"
              class="dev-tool-tooltip"
              role="tooltip">
          {{skipTooltip}}
        </span>
      </div>
    </div>
  </div>
</aside>
